import { getCenter } from '../helpers';
import { Point, Segment } from '@flatten-js/core';
import { Coordinate } from './coordinate';

export class Border {
  constructor(options) {
    ({
      planarea: this.planarea,
      startPoint: this.startPoint,
      endPoint: this.endPoint,
      isBaseBorder: this.isBaseBorder = false,
      borderDirection: this.borderDirection = BorderDirection.CLOCKWISE,
      index: this.index,
    } = options);
  }

  getCenter() {
    return getCenter(this.startPoint, this.endPoint);
  }

  getCenterWithOffset(offset) {
    const segment = this.getFlattenSegment();
    let vectorTransform = 0.5 * Math.PI;
    if (this.isClockwise()) {
      vectorTransform = vectorTransform * -1;
    }
    const vector = segment
      .tangentInStart()
      .normalize()
      .rotate(vectorTransform)
      .multiply(offset);
    const point = segment.middle().translate(vector);
    return new Coordinate(point.x, point.y);
  }

  isClockwise() {
    return this.borderDirection === BorderDirection.CLOCKWISE;
  }

  getFlattenSegment() {
    return new Segment(new Point(this.startPoint.x, this.startPoint.y), new Point(this.endPoint.x, this.endPoint.y));
  }

  canBeDeleted() {
    return this.planarea.areaState.canDeleteBorder(this.index);
  }

  getBreakerBoardPlankCount() {
    const breaker = this.planarea.areaState.getBreakerBoardOnIndex(this.index);
    if (breaker) {
      return breaker.plankCount;
    }
    return 0;
  }

  getBorderLabels() {
    return this.planarea.areaState.borderLabelState.getLabelsForBorder(this.index);
  }

  getAllBorderLabels() {
    return this.planarea.areaState.borderLabelState.allLabels;
  }

  addLabel(label) {
    return this.planarea.areaState.borderLabelState.addLabel(this.index, label);
  }

  removeLabel(label) {
    return this.planarea.areaState.borderLabelState.removeLabel(this.index, label);
  }

  getLength() {
    return this.getFlattenSegment().length;
  }
}

export const BorderDirection = Object.freeze({
  CLOCKWISE: Symbol('cw'),
  COUNTERCLOCKWISE: Symbol('ccw'),
});
